module.exports = __webpack_public_path__ + "static/media/binance.f081a1b2.svg";